<script>
  import { linkResolver } from "./prismic";

  export let page;
  export let title;
  export let description;
</script>

<svelte:head>
  <title>{title} - Hertz6</title>
  <meta name="description" content={description} />

  {#each page.social || [] as social}
    {#if social.__typename.indexOf("General_card") > -1}
      <meta property="og:title" content={social.primary.title[0].text} />

      <meta property="og:type" content="article" />

      <meta property="og:url" content={linkResolver(page._meta)} />

      {#if social.primary?.image?.url}<meta
          property="og:image"
          content={social.primary.image.url}
        />{/if}

      <meta
        property="og:description"
        content={social.primary.description[0].text}
      />

      <meta property="og:site_name" content="Hertz6" />
    {:else if social.__typename.indexOf("Twitter_card") > -1}
      <meta name="twitter:card" content={social.primary.card_type} />

      <meta name="twitter:title" content={social.primary.title[0].text} />

      <meta
        name="twitter:description"
        content={social.primary.description[0].text}
      />
      {#if social?.primary?.image}
        <meta name="twitter:image" content={social.primary.image.url} />
      {/if}
    {/if}
  {/each}

  <!-- Twitter Card data
    
  <meta name="twitter:card" content="summary">
    
  <meta name="twitter:site" content="@publisher_handle">
    
  <meta name="twitter:title" content="Page Title">
    
  <meta name="twitter:description" content="Page description less than 200 characters">
    
  <meta name="twitter:creator" content="@author_handle">
    
  <meta name="twitter:image" content="http://www.example.com/image.jpg">
    
    
  <meta property="og:title" content="Title Here" />
    
  <meta property="og:type" content="article" />
    
  <meta property="og:url" content="http://www.example.com/" />
    
  <meta property="og:image" content="http://example.com/image.jpg" />
    
  <meta property="og:description" content="Description Here" /> 
    
  <meta property="og:site_name" content="Site Name, i.e. Moz" />
    
  <meta property="fb:admins" content="Facebook numeric ID" /> -->
</svelte:head>
